// extracted by mini-css-extract-plugin
module.exports = {"wrapper-description":"DrawerDescription_wrapper-description__olq0g","product-name":"DrawerDescription_product-name__JCwLX","icon":"DrawerDescription_icon__VWSt4"};